import { dataSearchHistory } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSearchHistory = /*#__PURE__*/createIcon(dataSearchHistory)
export default IconSearchHistory
